"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SymfonyRouter_1 = __importDefault(require("@react/common/SymfonyRouter/SymfonyRouter"));
const GtmDataLayer_1 = __importDefault(require("@react/common/GtmDataLayer/GtmDataLayer"));
const Modal_1 = __importDefault(require("@web/common/Modal"));
const InputValidator_1 = __importDefault(require("@web/common/InputValidator"));
const DisplayAnimation_1 = __importDefault(require("@web/common/DisplayAnimation"));
(() => {
    const openEmailModalElement = document.querySelector('.main-menu-email-modal-open');
    const openPhoneModalElement = document.querySelector('.main-menu-phone-modal-open');
    const Message = {
        error: 'Něco se pokazilo, zkuste to prosím znovu.',
        successEmail: 'Děkujeme za zprávu, co nejdříve vám odpovíme!',
        successPhone: 'Děkujeme, co nejdříve vám zavoláme!',
        sending: 'Odesílám...',
    };
    function showResponseMessage(element, message, isError) {
        const parent = element.parentElement;
        const type = isError ? 'error' : 'success';
        if (parent === null) {
            return;
        }
        const messageExist = parent.querySelector(`.response-message.${type}`) !== null;
        if (messageExist === false) {
            parent.insertAdjacentHTML('beforeend', `<div class="response-message ${type}">${message}</div>`);
        }
    }
    function sendEmailRequest(formEmailContainer, emailInput, emailBodyInput, saveEmailButton) {
        const url = SymfonyRouter_1.default.getRoute('menu.email.api', {});
        const data = new FormData();
        data.append('emailAddress', window.btoa(emailInput.value));
        data.append('emailBody', emailBodyInput.value);
        let defaultSubmitButtonText;
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.onloadstart = () => {
            defaultSubmitButtonText = saveEmailButton.innerText;
            saveEmailButton.innerText = Message.sending;
        };
        xhr.onload = () => {
            if (xhr.status === 200) {
                DisplayAnimation_1.default.hide(formEmailContainer);
                showResponseMessage(formEmailContainer, Message.successEmail, false);
                (0, GtmDataLayer_1.default)({
                    event: 'main_menu_contacts_email_request',
                    eventLabel: emailInput.value,
                });
            }
            else {
                saveEmailButton.innerText = defaultSubmitButtonText;
                showResponseMessage(formEmailContainer, Message.error, true);
            }
        };
        xhr.send(data);
    }
    function sendPhoneRequest(formPhoneContainer, phoneInput, savePhoneButton) {
        const url = SymfonyRouter_1.default.getRoute('menu.phone.api', {});
        const data = new FormData();
        data.append('phone', phoneInput.value);
        let defaultSubmitButtonText;
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.onloadstart = () => {
            defaultSubmitButtonText = savePhoneButton.innerText;
            savePhoneButton.innerText = Message.sending;
        };
        xhr.onload = () => {
            if (xhr.status === 200) {
                DisplayAnimation_1.default.hide(formPhoneContainer);
                showResponseMessage(formPhoneContainer, Message.successPhone, false);
                (0, GtmDataLayer_1.default)({
                    event: 'main_menu_contacts_phone_request',
                    eventLabel: phoneInput.value,
                });
            }
            else {
                savePhoneButton.innerText = defaultSubmitButtonText;
                showResponseMessage(formPhoneContainer, Message.error, true);
            }
        };
        xhr.send(data);
    }
    function phoneFormAction(form) {
        const phoneInput = form.querySelector('.main-menu-phone-input');
        const savePhoneButton = form.querySelector('.main-menu-phone-save');
        if (phoneInput === null || savePhoneButton === null) {
            return;
        }
        form.addEventListener('submit', (event) => {
            event.preventDefault();
            if (InputValidator_1.default.isPhoneValid(phoneInput.value) === true) {
                sendPhoneRequest(form, phoneInput, savePhoneButton);
            }
        });
        phoneInput.addEventListener('blur', () => {
            InputValidator_1.default.validatePhoneInput(phoneInput);
        });
    }
    function initPhoneForm() {
        const phoneForm = document.querySelector('#main-menu-phone-form');
        if (phoneForm) {
            phoneFormAction(phoneForm);
        }
    }
    function emailFormAction(form) {
        const emailInput = form.querySelector('#main-menu-email-input');
        const emailBodyInput = form.querySelector('#main-menu-email-body-input');
        const saveEmailButton = form.querySelector('#main-menu-email-save');
        if (saveEmailButton === null || emailInput === null || emailBodyInput === null) {
            return;
        }
        form.addEventListener('submit', (event) => {
            event.preventDefault();
            if (InputValidator_1.default.isEmailValid(emailInput.value) === true && InputValidator_1.default.isTextValid(emailBodyInput.value) === true) {
                sendEmailRequest(form, emailInput, emailBodyInput, saveEmailButton);
            }
        });
        emailInput.addEventListener('blur', () => {
            InputValidator_1.default.validateEmailInput(emailInput);
        });
        emailBodyInput.addEventListener('blur', () => {
            InputValidator_1.default.validateTextInput(emailBodyInput, 'Vyplňte prosím text emailu.');
        });
    }
    if (openEmailModalElement) {
        (() => new Modal_1.default(openEmailModalElement))();
    }
    if (openPhoneModalElement) {
        (() => new Modal_1.default(openPhoneModalElement))();
    }
    document.addEventListener('ajax-modal-open-event', () => {
        const modal = document.querySelector('.modal');
        if (modal === null) {
            return;
        }
        initPhoneForm();
        const emailForm = modal.querySelector('#main-menu-email-form');
        if (emailForm) {
            emailFormAction(emailForm);
        }
    });
    initPhoneForm();
})();
